<template>
  <div class="login-test-page flex-cen-xy">
    <div class="login-form-box flex-xy">
      <el-form inline v-loading="loadding">
        <el-form-item label="账号：">
          <el-input style="" v-model="userId" />
        </el-form-item>
      </el-form>
      <el-button
        style="text-align: center"
        @click="toLogin"
        type="primary"
        :disabled="loadding"
        >登录</el-button
      >
    </div>
  </div>
</template>

<script>
import { login, getChannelSellerInfo, getMenus } from "@/api/testLogin/index";
export default {
  data() {
    return {
      userId: "",
      loadding: false,
    };
  },
  methods: {
    toLogin() {
      this.loadding = true;
      login({
        userId: this.userId,
      }).then((res) => {
        this.$message.success("登录成功");
        this.loadding = false;
        sessionStorage.setItem("isLogin", true);
        this.getSellerInfo();
        this.getMenusData();
      });
    },
    getSellerInfo() {
      getChannelSellerInfo().then((res) => {
        if (res.code === 200) {
          this.$store.dispatch("updateUserInfo", res.data);
        }
      });
    },
    getMenusData() {
      getMenus().then((res) => {
        console.log("res", res)
        if (res.code === 200) {
          let vdata = res.data;
          let fistMenuList = [];
          let childMenuList = [];
          vdata.forEach((item) => {
            fistMenuList.push({
              name: item.title,
              path: item.path,
            });
            if (!!item.children) {
              childMenuList.push(this.transformData(item.children));
            }
          });
          this.$store.dispatch("updateFistMenuList", fistMenuList);
          this.$store.dispatch("updateChildMenuList", childMenuList);
          this.$store.state.fistActIndex = 0;
          let path, childPath, childMenuData;
          let childMenuListNow = this.$store.getters.childMenuList;
          console.log("childMenuListNow", childMenuListNow)
          childMenuData = childMenuListNow[0][0];
          childPath = this.checkMenu(childMenuData);
          path = this.$store.state.fistMenuList[0].path + "" + childPath;
          console.log("path", path)
          this.$store.dispatch("updateActiveMenu", path);
          this.$router.push(path);
        }
      });
    },
    transformData(data) {
      return data.map((item) => ({
        name: item.title,
        path: `/${item.path}`,
        menuType: item.menuType,
        children:
          item.children && item.children.length > 0
            ? this.transformData(item.children)
            : null,
      }));
    },
    // 检查栏目拼接请求地址-menuType是M代表栏目，C代表页面
    checkMenu(dataObj) {
      let path = "";
      if (dataObj.menuType == "M" && !!dataObj.children) {
        let childrenPath = dataObj.children[0].path;
        path = dataObj.path + childrenPath;
        return path;
      } else {
        return dataObj.path;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-test-page {
  width: 100%;
  height: 100%;
  background: #f8f9fc;
  .login-form-box {
    width: 300px;
    height: 150px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 1.419px 6.364px 0px rgba(186, 209, 241, 0.5);
  }
}
</style>